import React, { useContext, useEffect } from 'react';
import { CartContext } from '../Cart/CartContext';
import { WishlistContext } from '../Wishlist/WishlistContext';
import { FaShoppingCart, FaBolt } from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
  const { cartItems, removeFromCart, increaseQuantity, decreaseQuantity, setCartItems } = useContext(CartContext);
  const { addToWishlist } = useContext(WishlistContext);

  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('userData'));
    if (!user) {
      const tempCart = JSON.parse(sessionStorage.getItem('tempCart')) || [];
      setCartItems(tempCart);
    }
  }, [setCartItems]);

  const handleAddToWishlist = (item) => {
    const wishlistItem = {
      id: item.id,
      name: item.name,
      image: item.image,
      price: item.price,
    };
    addToWishlist(wishlistItem);
    removeFromCart(item.productId || item.id, item.variantId);
    alert(`${item.name} added to your wishlist!`);
  };

  // Ensure values are valid numbers
  const getTotalPrice = () =>
    cartItems.reduce((total, item) => {
      const basePrice = parseFloat(item.price) || 0;
      const discount = parseFloat(item.discount || 0);
      const finalPrice = basePrice - (basePrice * discount / 100);
      const quantity = parseInt(item.quantity) || 1;
      return total + finalPrice * quantity;
    }, 0);

  const getTotalOriginalPrice = () =>
    cartItems.reduce((total, item) => {
      const originalPrice = parseFloat(item.originalPrice || item.mrp || item.price) || 0;
      const quantity = parseInt(item.quantity) || 1;
      return total + originalPrice * quantity;
    }, 0);

  // Subtract safely
  const savings = getTotalOriginalPrice() - getTotalPrice();

  const handleCheckout = () => {
    const userData = sessionStorage.getItem('userData');
    if (userData) {
      // Save cart data for checkout
      sessionStorage.setItem("checkoutCart", JSON.stringify(cartItems));
      sessionStorage.setItem("checkoutTotals", JSON.stringify({
        subtotal: getTotalPrice(),
        savings
      }));
      navigate('/checkout');
    } else {
      const loginBtn = document.getElementById("loginTriggerBtn");
      if (loginBtn) loginBtn.click();
    }
  };
  return (
    <>
      <Header />

      <div className="cart-container" style={{ paddingBottom: '150px' }}>
        {cartItems.length === 0 ? (
          <div className="empty-cart-container text-center d-flex flex-column justify-content-center align-items-center">
            <div className="empty-cart-card p-4">
              <FaShoppingCart size={80} color="#ff6f61" />
              <h3 className="mt-3 fw-bold">Your cart is empty</h3>
              <p className="text-muted">Looks like you haven’t added anything to your cart yet.</p>
              <button className="btn btn-primary mt-3 px-4 py-2">Start Shopping</button>
            </div>
          </div>
        ) : (
          <div className="container py-5" style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ marginBottom: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', color: '#333' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontWeight: '600', color: '#4CAF50' }}>
                  <FaBolt />
                  <span>YOUR BASKET</span>
                </div>
                <div>{cartItems.length} Product{cartItems.length > 1 ? 's' : ''}</div>
              </div>
              <hr />
              <div style={{ backgroundColor: '#f0f0f0', borderRadius: '6px', marginTop: '12px', padding: '10px 20px', display: 'grid', gridTemplateColumns: 'auto 120px 120px', fontWeight: '600', fontSize: '14px', color: '#555', }}>
                <div>Items</div>
                <div style={{ textAlign: 'center' }}>Quantity</div>
                <div style={{ textAlign: 'right' }}>Sub-total</div>
              </div>
            </div>

            {/* Cart Items */}
            {cartItems.map(item => {
              const originalPrice = parseFloat(item.originalPrice || item.mrp || item.price);
              const basePrice = parseFloat(item.price);
              const discount = parseFloat(item.discount || 0);
              const price = basePrice - (basePrice * discount / 100);
              console.log('Offer Price for', item.name, ': ₹', price.toFixed(2));

              const quantity = item.quantity || 1;
              const totalPrice = price * quantity;
              const totalOriginalPrice = originalPrice * quantity;
              const savings = totalOriginalPrice - totalPrice;

              return (
                <div key={item.id || `${item.productId}-${item.variantId}`} style={{ border: '1px solid #d2e8b6', borderRadius: '8px', overflow: 'hidden', marginBottom: '16px', height: '180px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', padding: '16px' }}>
                    <div style={{ width: '140px', height: '140px', marginRight: '20px' }}>
                      <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '6px' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: '500', fontSize: '15px', marginBottom: '6px' }}>{item.name}</div>
                      <div style={{ fontSize: '14px', color: '#333' }}>
                        ₹{price}
                        {originalPrice > price && (
                          <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '13px', marginLeft: '8px' }}>₹{originalPrice}</span>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                      <div style={{ display: 'inline-flex', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
                        <button onClick={() => decreaseQuantity(item.productId || item.id, item.variantId)} style={{ padding: '4px 18px', background: '#fff', border: 'none', cursor: 'pointer', fontSize: '16px' }}>−</button>
                        <div style={{ padding: '4px 16px', borderLeft: '1px solid #ccc', borderRight: '1px solid #ccc', fontSize: '14px', fontWeight: '500' }}>{quantity}</div>
                        <button onClick={() => increaseQuantity(item.productId || item.id, item.variantId)} style={{ padding: '4px 18px', background: '#fff', border: 'none', cursor: 'pointer', fontSize: '16px' }}>+</button>
                      </div>
                      <div style={{ fontSize: '13px', display: 'flex', gap: '12px' }}>
                        <button onClick={() => removeFromCart(item.productId || item.id, item.variantId)} style={{ color: '#d9534f', background: 'none', border: 'none', cursor: 'pointer' }}>Delete</button>
                        <button onClick={() => handleAddToWishlist(item)} style={{ color: '#007bff', background: 'none', border: 'none', cursor: 'pointer' }}>Save for later</button>
                      </div>
                    </div>
                    <div style={{ textAlign: 'right', minWidth: '100px', marginLeft: '20px' }}>
                      <div style={{ fontWeight: 'bold' }}>₹{totalPrice.toFixed(0)}</div>
                      {savings > 0 && (
                        <div style={{ fontSize: '13px', color: '#4d8f00', marginTop: '4px' }}>
                          Saved: ₹{savings.toFixed(0)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* === Sticky Checkout Bar === */}
        {cartItems.length > 0 && (
          <div style={{ position: 'fixed', bottom: '0px', left: '0', right: '0', background: '#111', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', boxShadow: '0 -2px 10px rgba(0,0,0,0.4)', zIndex: 1000, maxWidth: '1200px', margin: '0 auto', borderRadius: '8px 8px 0 0' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', fontSize: '16px' }}>Subtotal: ₹{getTotalPrice().toFixed(0)}</div>
              <div style={{ fontSize: '13px', color: '#8bc34a', marginTop: '4px' }}>Savings: ₹{savings.toFixed(0)}</div>
            </div>
            <button onClick={handleCheckout} style={{ background: '#0357a0', color: '#fff', border: 'none', borderRadius: '6px', padding: '14px 30px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer', boxShadow: '0 4px 10px rgba(255, 255, 255, 0.6)' }}>
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Cart;
